export * from "./truncateText";
